import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'

import { PaginationContext } from '../../context/pagination'
import { NextDisabledContext } from '../../context/nextDisabled'

import File from './questions'
import Questionnaire1 from './questionnaire_p1'
import Questionnaire2 from './questionnaire_p2'
import queryString from 'query-string'
import FetchWrapper from '../../utils/fetch_wrapper'

import config from '../../utils/config'

class Questionnaire extends Component {
  constructor(props) {
    super(props)
    this.state = {
      personalityType: '',
      loading: true,
      nextDisabled: false
    }
    this.updateActivePage = this._updateActivePage.bind(this)
    document.title = "Personality Assessment"
  }

  static getPageCount() {
    return 1
  }

  _updateActivePage(n) {
    this.context.updateActivePage(this.props.match.path, n)
  }

  async componentDidMount() {
    const plId = queryString.parse(window.location.search).plId
    await this.props.getStepCompleted(plId)
    this.setState({ loading: false })
  }

  componentDidUpdate() {
    if (this.shouldRedirect()) {
      let result = this.props.setShouldRedirect(true)
      if (result) this.setState({ nextDisabled: false })
    } else {
      this.props.setShouldRedirect(false)
    }
  }

  async _nextPage(history, cur, input) {
    const plId = queryString.parse(history.location.search).plId
    if (this.state.nextDisabled) return null
    switch(cur) {
      case '/':
        this.setState({
          nextDisabled: true
        }, async () => {
          await this.props.getStepCompleted(plId)
          if (window.location.pathname !== '/questionnaire') return null
          let upserted = await this.upsert(input)
          let processed = await this.processQuestionnaire()
          if (upserted && processed) {
            return history.push('/result' + history.location.search)
          }
          return this.props.error()
        })
        break
      case '/result':
        return this.props.next()
      default: return null
    }
  }

  async upsert(input) {
    let questions = {}
    let answers = {}
    File.pages[0].questions.map(question => {
      questions[question.key] = { text: question.text, title: File.pages[0].title }
      for (let index in question.fields) {
        if (question.fields[index].value === input[question.key].value) {
          answers[question.key] = [{ value: input[question.key].value, text: question.fields[index].text, id: question.fields[index].id, upsertKey: question.fields[index].upsertKey}]
          break
        }
      }
    })
    const code = queryString.parse(this.props.location.search)
    const params = {
      stringifiedQuestions: JSON.stringify(questions), 
      stringifiedAnswers: JSON.stringify(answers),
      pageNumber: 2,
      plId: parseInt(code.plId)
    }
    try {
      let response = await FetchWrapper.fetch(config.endpoint_upsert_qna, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      return true
    } catch(error) {
      return false
    }
  }

  async processQuestionnaire() {
    const code = queryString.parse(this.props.location.search)
    const params = {
      plId: parseInt(code.plId),
      RegCode: code.regCode,
      NextStepUrl: window.location.origin
    }
    try {
      let response = await FetchWrapper.fetch(config.endpoint_process_questionnaire, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      this.setState({
        personalityType: response.data.result,
        nextDisabled: false
      })
      return true
    } catch(error) {
      this.setState({ nextDisabled: false })
      return false
    }
  }

  shouldRedirect() {
    if (!this.props.nextStepPath) return true
    const n = this.props.nextStepPath.search('\\?')
    let nextPath = this.props.nextStepPath.substring(0, n)
    if ((nextPath === '/questionnaire' && window.location.pathname === '/questionnaire/result') || 
        (nextPath === '/questionnaire' && window.location.pathname === '/questionnaire')) {
      return false
    }
    return true
  }

  extendRoute(R) {
    return props => {
      return <R 
        {...props}
        {...File.pages[0]}
        personalityType={this.state.personalityType}
        updateActivePage={this.updateActivePage}
        next={this._nextPage.bind(this, props.history)}
      />
    }
  }
  
  render() {
    if (this.state.loading) return <div></div>
    return (
      <div id="questionnaire">
        <NextDisabledContext.Provider value={this.state.nextDisabled}>
          <Router basename={this.props.match.path}>
            <Switch>
              <Route exact path="/" render={this.extendRoute(Questionnaire1)} />
              <Route path="/result" render={this.extendRoute(Questionnaire2)} />
            </Switch>
          </Router>
        </NextDisabledContext.Provider>
      </div>
    )
  }
}

Questionnaire.contextType = PaginationContext

export default Questionnaire